// extracted by mini-css-extract-plugin
var _1 = "PartSvg__baseAsset--kHAdH";
var _2 = "PartSvg__main--Ewgc9";
export { _1 as "baseAsset", _2 as "main" }
